import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function registerEnrollment(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.registerEnrollment.url, { id }))
    .post<unknown, never>()
}
